<template>
  <div>
    <template v-if="showTaskInfo">
      <p>Препарат: <strong>{{ task.task_data?.drug?.title }}</strong></p>
      <p>{{ task.task_data?.drug?.group }}</p>
      <p v-if="task.task_data?.comment">{{ task.task_data.comment }}</p>
    </template>
    <div :class="{'mt-2': showTaskInfo}">
      <CommentsBlock ref="commentBlock" :task="task" :updateTasks="updateTasks"/>
    </div>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import CommentsBlock from "../components/CommentsBlock.vue"

export default {
  components: {CommentsBlock, LoadingButton},
  props: ['task', 'updateTasks', 'showTaskInfo'],
  data() {
    return {}
  },
  created() {
    if (!this.task?.task_data) {
      // this.$set(this.task, 'task_data', {comment: ''});
    }
  },
  methods: {}
}

</script>
